module.exports = __webpack_public_path__ + "entry-41b28522/johanna-eckert.256x256-6df71c7338b4686ab94c3b15531d8338.webp";